// extracted by mini-css-extract-plugin
export default {"messagePage":"messagePage--k4O3U","emptyStyle":"emptyStyle--UATWp"};